import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ReactComponent as AddRoomButtonSVG } from 'assets/images/queue.svg';

import styles from '../CancellationPolicy.module.scss';

const cx = classNames.bind(styles);
function CreateCancelPolicy(props) {
  const { onClick, cancelBookingPolicyList } = props;

  return (
    <button
      type="button"
      className={cx('CreateCard', {
        disabled: cancelBookingPolicyList.length >= 3,
      })}
      onClick={onClick}
      disabled={cancelBookingPolicyList.length >= 3}
    >
      <AddRoomButtonSVG />
      <p>TẠO CHÍNH SÁCH MỚI</p>
      <span>Tối đa 3 chính sách</span>
    </button>
  );
}

CreateCancelPolicy.propTypes = {
  onClick: PropTypes.func,
  cancelBookingPolicyList: PropTypes.instanceOf(Array),
};

CreateCancelPolicy.defaultProps = {
  onClick: () => {},
  cancelBookingPolicyList: [],
};

export default CreateCancelPolicy;
